<template>
  <transition name="loading">
    <div :class="classes">
      <img
        :src="assetPath('logo.svg')"
        :alt="t('global.title')"
        class="page-loading__img"
        @load="imageLoaded"
      />
      <div class="app__version">
        {{ appVersion }}
      </div>
    </div>
  </transition>
</template>

<script>
  import { assetPath } from '@/util'
  import { useStrings } from '@/composables/useStrings.ts'
  import { APP_VERSION } from '@/constants.ts'

  export default {
    name: 'loading',
    data: () => {
      return {
        imageLoading: true,
      }
    },
    setup() {
      const { t } = useStrings()

      return {
        assetPath,
        t,
        appVersion: APP_VERSION,
      }
    },
    methods: {
      imageLoaded() {
        this.imageLoading = false
      },
    },
    computed: {
      classes() {
        let result = ['page-loading']
        if (!this.imageLoading) {
          result.push('page-loading--loaded')
        }

        return result
      },
    },
  }
</script>

<style lang="scss">
  .page-loading {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;

    &__img {
      opacity: 0;
      position: absolute;
      left: 50%;
      top: 45%;
      max-width: $loading-img-max-width;
      height: auto;
      transform: translate(-50%, -50%);
      transition: opacity $loading-fadein-duration ease 0s;

      @media (min-width: $bp-lg) {
        max-width: $loading-img-max-width-lg;
      }

      .page-loading--loaded & {
        opacity: 1;
      }
    }
  }
</style>
